import { useNavigate } from 'react-router-dom';

import { AudienceCreateMutation } from '@occc/graphql';
import { useAudienceCreateMutation } from '@occc-app/dataAccessLayer/audience/mutations';
import { audienceFormInitialValues } from '@occc-app/routes/Audience/AudienceCreatePage/AudienceFormInitialValues';
import { useChainId } from '@occc-app/Chain/hooks';

import { AudienceCreatePage } from './AudienceCreatePage';
import { prepareAudienceCreateInput } from './utils';

import { routeCreator } from '../utils';
import { AudienceFormValues } from '../types';
import { useOpenAndScrollToInvalidSection, useValidateAudience } from '../hooks';

export const AudienceCreatePageContainer = () => {
  const navigate = useNavigate();
  const chainId = useChainId();
  const validateAudience = useValidateAudience();
  const onCompleted = (mutation: AudienceCreateMutation) =>
    navigate(routeCreator.details(mutation.audienceCreate.uuid));

  const [audienceCreateMutation] = useAudienceCreateMutation({ onCompleted });
  const openAndScrollToInvalidSection = useOpenAndScrollToInvalidSection();

  const audienceCreate = (values: AudienceFormValues) => {
    const input = prepareAudienceCreateInput(chainId, values);
    return audienceCreateMutation({ variables: { input } });
  };

  return (
    <AudienceCreatePage
      initialValues={audienceFormInitialValues}
      audienceCreate={audienceCreate}
      validate={validateAudience}
      openAndScrollToInvalidSection={openAndScrollToInvalidSection}
    />
  );
};
